import TemplateCollapsibleCards from './TemplateCollapsibleCards';



export default TemplateCollapsibleCards;
